<script setup lang="ts">
  import { computed, withDefaults, defineEmits } from 'vue';
  import { useRouter } from 'vue-router';
  import { MpfBackLinkProps } from './MpfBackLink.props';
  import { defaultProps, emitDef } from './MpfBackLink.props';
  const router = useRouter();

  const props = withDefaults(defineProps<MpfBackLinkProps>(), defaultProps);

  const emit = defineEmits(emitDef);

  const computedAriaLabel = computed(() =>
    props.ariaLabel && props.ariaLabel.length ? props.ariaLabel : undefined,
  );

  const onClick = (event: MouseEvent) => {
    if (props.historyBack) {
      router.back();
      return;
    }
    emit('click', event);
  };
</script>

<template>
  <a
    class="mpf-back-link"
    :class="{ 'mpf-back-link--reverse': reverse }"
    :href="href"
    :aria-label="computedAriaLabel"
    @click="onClick"
  >
    <slot>{{ text }}</slot>
  </a>
</template>

<style scoped lang="scss">
  @use './MpfBackLink.scss';
</style>
